const themeLight = {
  // ===== Page Background=====
  bg: "#F5F5F7", 
  pageBackground: "linear-gradient(180deg, #F5F5F7 0%, #E8ECF3 100%)",

  // ===== Card=====
  card: "rgba(255, 255, 255, 0.65)", 
  glass: "rgba(255, 255, 255, 0.75)",

  // ===== Text =====
  text: "#1D1D1F",             
  muted: "#86868B",            

  // ===== Border=====
  border: "rgba(0, 0, 0, 0.05)", 

  // ===== Glow & Shadow=====
  glow: "0 10px 40px rgba(0, 0, 0, 0.06)", 

  // ===== Primary Color=====
  primary: "#8bbbe7ff",          
  primaryHover: "#4e95f1ff",
  secondary: "#bbe0ebff", 

  // ===== Logo =====
  logoBackground: "linear-gradient(135deg, #2980b9, #6dd5fa)",

  // ===== Section Header Bar =====
  gradientBar: "linear-gradient(90deg, #0071E3, #4facfe)",
  barshadow: "rgba(0, 113, 227, 0.15)",

  // ===== TextArea=====
  textAreaBackground: "rgba(0, 0, 0, 0.03)", 
  textAreaBoxshadow: "none", 

  // ===== Tip =====
  tipBackground: "rgba(255, 255, 255, 0.8)",
  tipBoxshadow: "0 4px 12px rgba(0, 0, 0, 0.05)",

  // ===== Navigation Text =====
  navText: "#515154",
  navTextActive: "#0071E3",
  navTextHover: "#1D1D1F",

  // ===== Navigation Backgrounds =====
  navActiveBackground: "rgba(0, 113, 227, 0.1)", 
  navHoverBackground: "rgba(0, 0, 0, 0.04)",

  // ===== Navigation Shadows & Structure =====
  navHoverShadow1: "none", 
  navHoverShadow2: "none",
  navcard: "rgba(255, 255, 255, 0.8)", 
  navBorder: "rgba(0, 0, 0, 0.05)",    

  //Error
  errorBackground: "rgba(255, 0, 0, 0.08)",
  errorBorder: "rgba(255, 0, 0, 0.25)",
  errorText: "#d23a3a",
  //Highlight
  textHighlight: "#000000",

  // ===== Label =====
  modeLabel: "Daylight",
};

export default themeLight;
